<template>
  <div class="enterpriseList">
    <v-publiceTit :titleObj="titleObj"></v-publiceTit>
    <ul class="clearfix">
      <li class="col-xs-3 col-sm-3 col-md-2 col-lg-2"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplier_logo01.png" alt=""></li>
      <li class="col-xs-3 col-sm-3 col-md-2 col-lg-2"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplier_logo02.png" alt=""></li>
      <li class="col-xs-3 col-sm-3 col-md-2 col-lg-2"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplier_logo03.png" alt=""></li>
      <li class="col-xs-3 col-sm-3 col-md-2 col-lg-2"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplier_logo04.png" alt=""></li>
      <li class="col-xs-6 col-sm-6 col-md-2 col-lg-2"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplier_logo05.png" alt=""></li>
      <li class="col-xs-6 col-sm-6 col-md-2 col-lg-2"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplier_logo06.jpg" alt=""></li>
    </ul>
  </div>
</template>
<script>
import publiceTit from '@/components/publiceTit'
export default {
  data () {
    return {
      titleObj: {name: '入驻供应商', eng: 'Supplier entry'}
    }
  },
  components: {
    'v-publiceTit': publiceTit
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/enterpriseList/index.vue